import { render, staticRenderFns } from "./SimpleAndonManagement.vue?vue&type=template&id=649e1a0b&scoped=true&"
import script from "./SimpleAndonManagement.vue?vue&type=script&lang=js&"
export * from "./SimpleAndonManagement.vue?vue&type=script&lang=js&"
import style0 from "./SimpleAndonManagement.vue?vue&type=style&index=0&id=649e1a0b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649e1a0b",
  null
  
)

export default component.exports